import FactsTable from './FactsTable';

export default FactsTable;
